import React from 'react';
import withMarketPreOpen from '../../../common/market-pre-open/withMarketPreOpen';
import Chart from './Chart';
import PriceInfo from './PriceInfo';
import Table from './Table';
import { fetchListTable, subscribeRealtimeData } from './reducer';
import Footer from '../../../common/table/Footer';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withRealtime from './../../../common/withRealtime';
import { I18n } from 'react-redux-i18n';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class Index2 extends AutoReloadOnFocusBlurComponent {
  reload() {
    const { fetchListTable } = this.props;
    fetchListTable(999999, 1);
  }

  componentDidMount() {
    super.componentDidMount();
    const { fetchListTable } = this.props;
    fetchListTable(999999, 1);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <div className="tab-pane h-100 active d-flex flex-fill flex-column pl-20 pr-20">
        <div className="d-flex mb-10 flex-shrink-0">
          <div className="w-185px">
            <PriceInfo />
          </div>
          <div className="w-100-185px d-flex flex-fill">
            <Chart />
          </div>
        </div>
        <Table />
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = {
  subscribeRealtimeData,
  fetchListTable,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withRealtime(ChanelConfig.IndexChannel, 'subscribeRealtimeData'),
  //withMarketPreOpen('flex-fill'), -- hidden preopen market clock
)(Index2);
